/**
 *
 * DetailImageAndLabel
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _isEmpty from 'lodash/isEmpty';
import _has from 'lodash/has';
import ResourceLabel from 'components/ResourceLabel';
import ClassNames from 'classnames';
import { getImageFile, fallbackImage } from 'utils/stringUtils';
import Parser from 'html-react-parser';
import Colors from 'utils/colors';
import Avatar from '@material-ui/core/Avatar';
import Popover from '@material-ui/core/Popover';
import Player from 'components/AudioCard/Player';

const styles = () => ({
  image: {
    width: '100%',
    maxWidth: '100%',
    maxHeight: 280,
    cursor: 'pointer',
  },
  brokenImage: {
    height: 100,
    width: '100%',
  },
  imageWrapper: {
    position: 'relative',
    marginBottom: 17,
    minHeight: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // '& > div': {
    //   bottom: '-20px',
    //   left: 0,
    //   height: 20,
    // },
    '& a > img': {
      width: 'auto',
      maxHeight: 280,
      maxWidth: '100%',
    },
  },
  labelWrapper: {
    '& > div': {
      height: 20,
      position: 'relative',
    },
  },
  articleImage: {
    alignItems: 'flex-start',
    height: 174,
    justifyContent: 'flex-start',
  },
  noMarginBottom: {
    marginBottom: 0,
  },
  appImage: {
    border: '1px solid #D8D8D8',
    borderRadius: 24,
    padding: 0,
  },
  personImage: {
    height: 192,
    width: 192,
  },
  attribution: {
    fontSize: 12,
    color: 'gray',
    fontStyle: 'italic',
    marginTop: '-10px',
    '& a': {
      color: Colors.link,
    },
  },
  popover: {
    padding: 15,
  },
});

function DetailImageAndLabel(props) {
  const {
    classes,
    data,
    type,
    defaultImage,
    render,
    withLinks,
    listenNotesData,
  } = props;
  const file = defaultImage || getImageFile(data);
  const hasAttribution = _has(data, 'imageAttribution');
  const [anchorEl, setAnchorEl] = React.useState(null);
  function handleClick(event) {
    if (!withLinks) return;
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }
  const open = Boolean(anchorEl);
  const id = open ? 'menu-popover' : undefined;
  if (!_isEmpty(listenNotesData)) {
    const { thumbnail, audio, episodes } = listenNotesData;
    let finalThumbnail = thumbnail;
    let finalAudio = audio;
    if (!_isEmpty(episodes)) {
      finalThumbnail = episodes[0].thumbnail;
      finalAudio = episodes[0].audio;
    }
    return (
      <Player
        thumbnail={finalThumbnail}
        audio={finalAudio}
        data={data}
        section="page"
      />
    );
  }
  return (
    <>
      {withLinks && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          classes={{
            paper: classes.popover,
          }}
        >
          {render()}
        </Popover>
      )}

      <Grid
        item
        xs={12}
        className={ClassNames(classes.imageWrapper)}
        onClick={handleClick}
      >
        {!_isEmpty(file) && type !== 'person' ? (
          <img
            src={file}
            onError={e => {
              e.target.src = fallbackImage;
            }}
            className={ClassNames(
              classes.image,
              type === 'apps' ? classes.appImage : null,
            )}
            alt="Detail"
          />
        ) : !_isEmpty(file) && type === 'person' ? (
          <Avatar
            src={file}
            className={classes.personImage}
            alt="Resource Image"
          />
        ) : (
          <img
            src={fallbackImage}
            onError={e => {
              e.target.src = fallbackImage;
            }}
            className={ClassNames(
              classes.image,
              type === 'apps' ? classes.appImage : null,
            )}
            alt="Detail"
          />
        )}
      </Grid>
      <Grid item xs={12} className={classes.labelWrapper}>
        <ResourceLabel labels={data.labels} />
      </Grid>
      {hasAttribution && (
        <Grid item xs={12} className={classes.attribution}>
          {Parser(data.imageAttribution)}
        </Grid>
      )}
    </>
  );
}
DetailImageAndLabel.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  type: PropTypes.string,
  defaultImage: PropTypes.string,
  render: PropTypes.func,
  withLinks: PropTypes.bool,
  listenNotesData: PropTypes.object,
};

export default withStyles(styles)(DetailImageAndLabel);
